<template>
  <div class="download">
    <div class="wx-mask-wrap" v-if="topShow"></div>
    <div class="download_tips" v-if="topShow" >
      <img v-if="topShow" src="@/assets/images/common/download-tip-text.jpg" alt="">
    </div>
    <div class="download_title">
      <img src="@/assets/images/common/download-title-text.jpg" alt="">
    </div>
    <div class="footer" @click="download">
      <div class="title">立即下载“响锣店群骑手版”APP</div>
    </div>
  </div>
</template>

<script>
import config from '@/config/index'
export default {
  data () {
    return {
      topShow: true
    }
  },
  methods: {
    download () {
      const ua = navigator.userAgent.toLowerCase()
      const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
      const isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // ios
        window.location = 'itms-apps://itunes.apple.com/app/id1542584530';
        // this.$toast('暂不支持IOS')
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // android
        window.location = `http://file.xljielong.com/app/android/knight_${config.appEnv}_lastversion.apk`
      }
    },
    isWeiXin () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        this.topShow = false
      }
    }
  },
  mounted () {
    this.isWeiXin()
  }
}
</script>

<style lang='less' scoped>
  .download {
    width: 100%;
    height: 100%;
    background: url('~@/assets/images/common/download-bg3.jpg') no-repeat;
    background-size: cover;
    overflow: hidden;
    position: relative;
    .download_tips {
      position: relative;
      z-index: 20;
      text-align: right;
      padding-top: 27/2px;
      margin-right: 25px;
      img {
        width: 388/2px;
        height: 48/2px;
      }
    }

    .wx-mask-wrap{
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top:0;z-index: 19;
      background-color: rgba(0,0,0,.6);
    }
    .download_title {
      position: absolute;
      bottom: 180px;
      left: 50%;
      transform: translateX(-50%);

      img {
        height: 50px;
      }
    }
    .footer {
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      width: 632/2px;
      height: 234/2px;
      background: url('~@/assets/images/common/downloadbutton.png') no-repeat;
      background-size: 100% 100%;
      .title {
        position: relative;
        top: 34px;
        font-size: 16px;
        color: #fff;
        text-align: center;
      }
    }
  }
</style>
